import _defineProperty from "/home/vsts/work/r1/a/artifacts/source-code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { IMediaType } from '@monofe/ui-workspace/download-tour';
import { IFeatureStatus, injectMimeType, memoize, memoizeAsync, stringTools, urlTools } from '@monofe/util';
import { injectSiteConfig } from './siteConfig';
import siteData from './siteData';
export const resolverData = {
  mediaPrefix: undefined,
  mediaSchema: undefined,
  downloadList: undefined
};
const MIMETYPE_WEIGHTING_MAP_STREAM = {
  'application/x-mpegURL': 1,
  'video/mp4': 2
};
const MIMETYPE_WEIGHTING_MAP_DOWNLOAD = {
  'image/avif': 1,
  'image/webp': 2,
  'image/png': 8,
  'image/jpeg': 9,
  'image/jpg': 9,
  'video/webm': 2,
  'video/mp4': 3,
  'audio/ogg': 4,
  'audio/mpeg': 5,
  'text/html': 9,
  'text/plain': 10
};

const MIMETYPE_WEIGHTING_MAP_ALL = _objectSpread(_objectSpread({}, MIMETYPE_WEIGHTING_MAP_STREAM), MIMETYPE_WEIGHTING_MAP_DOWNLOAD);

function _prioritizeAssets(sortAssets, priorities) {
  const mimeTypeResolver = injectMimeType();
  const versions = [...sortAssets].sort((itemA, itemB) => {
    var _ref, _itemA$mimeType, _ref2, _itemB$mimeType, _priorities$mimeTypeA, _priorities$mimeTypeB;

    const mimeTypeA = (_ref = (_itemA$mimeType = itemA.mimeType) !== null && _itemA$mimeType !== void 0 ? _itemA$mimeType : mimeTypeResolver.fileExtensionToMimeType(itemA.path)) !== null && _ref !== void 0 ? _ref : 'text/plain';
    const mimeTypeB = (_ref2 = (_itemB$mimeType = itemB.mimeType) !== null && _itemB$mimeType !== void 0 ? _itemB$mimeType : mimeTypeResolver.fileExtensionToMimeType(itemB.path)) !== null && _ref2 !== void 0 ? _ref2 : 'text/plain';
    const weightingA = (_priorities$mimeTypeA = priorities[mimeTypeA]) !== null && _priorities$mimeTypeA !== void 0 ? _priorities$mimeTypeA : Number.MAX_SAFE_INTEGER;
    const weightingB = (_priorities$mimeTypeB = priorities[mimeTypeB]) !== null && _priorities$mimeTypeB !== void 0 ? _priorities$mimeTypeB : Number.MAX_SAFE_INTEGER;
    return weightingA - weightingB;
  });
  return versions;
}

function _assetSupportResolver(query, mimeType) {
  const mimeTypeResolver = asset => {
    var _ref3, _asset$mimeType;

    return (_ref3 = (_asset$mimeType = asset.mimeType) !== null && _asset$mimeType !== void 0 ? _asset$mimeType : mimeType.fileExtensionToMimeType(asset.path)) !== null && _ref3 !== void 0 ? _ref3 : 'text/plain';
  };

  const supportResolver = async asset => {
    const status = await query.mediaSupported([mimeTypeResolver(asset)]).catch(error => IFeatureStatus.FeatureStatusUnsupported);
    return status === IFeatureStatus.FeatureStatusSupported;
  };

  return memoizeAsync(supportResolver);
}

function _urlBuilder(asset) {
  var _asset$dependencies;

  /* Get <base href> value */
  const publicUrl = injectSiteConfig().public_url;
  const publicPrefix = publicUrl ? new URL(publicUrl).pathname : '/';
  const urls = ((_asset$dependencies = asset.dependencies) !== null && _asset$dependencies !== void 0 ? _asset$dependencies : [asset]).map(version => {
    var _asset$prefix;

    return (
      /* Make sure to use asset.prefix as it's the parent IMediumAssetSchema, the child may or may not have the prefix set */

      /* E.g. /c/demo  /assets  /SjFaN3dSRW8rNUo1b0tiR2NrWFFmUT09/contents  audio/click.mp3 */
      [publicPrefix, resolverData.mediaPrefix, (_asset$prefix = asset.prefix) !== null && _asset$prefix !== void 0 ? _asset$prefix : '', version.path].join('/')
    );
  }).map(urlPath => urlTools.sanitizePath(urlPath, {
    requireLeadingSlash: false
  })).map(pathUrl => new URL(pathUrl, publicUrl));
  return urls;
}

function _assetFromUrl(url) {
  var _resolverData$mediaSc, _resolverData$mediaSc2;

  const path = stringTools.addLeading(url.pathname, '/');
  /* Get <base href> value */

  const publicUrl = injectSiteConfig().public_url;
  const publicPrefix = publicUrl ? new URL(publicUrl).pathname : '/';

  if (resolverData.mediaPrefix === undefined || !path.startsWith(publicPrefix)) {
    return undefined;
  }

  const versionPath = urlTools.sanitizePath(stringTools.addLeading(path.replace(publicUrl, '/').replace(publicPrefix, '/').replace(resolverData.mediaPrefix, '/'), '/'));
  const media = (_resolverData$mediaSc = (_resolverData$mediaSc2 = resolverData.mediaSchema) === null || _resolverData$mediaSc2 === void 0 ? void 0 : _resolverData$mediaSc2.media) !== null && _resolverData$mediaSc !== void 0 ? _resolverData$mediaSc : [];
  const matchingMedia = media.flatMap(item => item.versions).flatMap(item => {
    var _item$dependencies;

    return [item, ...((_item$dependencies = item.dependencies) !== null && _item$dependencies !== void 0 ? _item$dependencies : [])];
  }).filter(version => version.path === versionPath).at(-1);
  return matchingMedia;
}

function buildTourDataResolver(query, mimeType) {
  const assetFromUrl = memoize(_assetFromUrl);

  const assetSupportResolver = _assetSupportResolver(query, mimeType);

  const urlBuilder = memoize(_urlBuilder);
  return {
    get: (name, pk) => {
      const result = siteData.get(name, pk);

      if (result === undefined) {
        throw new Error("Unable to find entity: ".concat(name, ":").concat(pk));
      }

      return Promise.resolve(result);
    },
    all: name => Promise.resolve(siteData.all(name)),
    downloadList: () => {
      var _resolverData$downloa;

      return Promise.resolve((_resolverData$downloa = resolverData.downloadList) !== null && _resolverData$downloa !== void 0 ? _resolverData$downloa : []);
    },
    urlsForMedium: async function (medium) {
      var _resolverData$mediaSc3, _resolverData$mediaSc4;

      let types = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [IMediaType.Stream, IMediaType.Download];
      const media = (_resolverData$mediaSc3 = (_resolverData$mediaSc4 = resolverData.mediaSchema) === null || _resolverData$mediaSc4 === void 0 ? void 0 : _resolverData$mediaSc4.media) !== null && _resolverData$mediaSc3 !== void 0 ? _resolverData$mediaSc3 : [];
      const matches = media.filter(item => item.sourceGuid === medium.id);
      const primaryMatch = matches.at(0);

      if (!primaryMatch) {
        throw new Error("No matches found for: ".concat(medium.id));
      }

      let mimeTypePriorities = MIMETYPE_WEIGHTING_MAP_ALL;

      if (types.length === 1 && types.at(0) === IMediaType.Stream) {
        mimeTypePriorities = MIMETYPE_WEIGHTING_MAP_STREAM;
      } else if (types.length === 1 && types.at(0) === IMediaType.Download) {
        mimeTypePriorities = MIMETYPE_WEIGHTING_MAP_DOWNLOAD;
      }

      const versions = _prioritizeAssets(primaryMatch.versions, mimeTypePriorities);

      for (const version of versions) {
        const hasSupport = await assetSupportResolver(version);

        if (!hasSupport) {
          continue;
        }

        const urls = urlBuilder(version);
        return urls;
      }

      throw new Error("No supporting files found: ".concat(versions.toString()));
    },
    urlContentLength: url => {
      var _asset$size;

      const asset = assetFromUrl(url);
      return Promise.resolve((_asset$size = asset === null || asset === void 0 ? void 0 : asset.size) !== null && _asset$size !== void 0 ? _asset$size : -1);
    }
  };
}

export default buildTourDataResolver;